<div class="modal-header">
	<h5 class="modal-title"><span jhiTranslate="inventory-details.nav.transaction"></span></h5>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
	</button>
</div>
<div class="modal-body">
	<iframe id="transactionDetailsModalIFrame" width="100%" height="570" frameborder="0"
			[src]="url"></iframe>
</div>
